var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDocClassifications(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-doc-classifications_svg__clip0_772_1643)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.685.761a1.8 1.8 0 00-1.8 1.8v3.674a1.8 1.8 0 001.8 1.8h1.262v2.526H5.623a1.8 1.8 0 00-1.8 1.8v.65H2.56A1.8 1.8 0 00.761 14.81v3.675a1.8 1.8 0 001.8 1.799h3.674a1.8 1.8 0 001.8-1.8V14.81a1.8 1.8 0 00-1.8-1.8H4.972v-.65a.651.651 0 01.65-.65h9.8a.65.65 0 01.65.65v.65H14.81a1.8 1.8 0 00-1.8 1.8v3.674a1.8 1.8 0 001.8 1.8h3.674a1.8 1.8 0 001.8-1.8V14.81a1.8 1.8 0 00-1.8-1.799h-1.263v-.65a1.8 1.8 0 00-1.799-1.799h-4.327V8.035h1.265a1.8 1.8 0 001.799-1.8V2.56a1.8 1.8 0 00-1.8-1.799H8.686z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-doc-classifications_svg__clip0_772_1643"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.761 .761)",
    d: "M0 0h19.523v19.523H0z"
  })))));
}
export default SvgIconDocClassifications;